import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";

import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import CompanyForm from "../../components/forms/CompanyForm";
import { FormMode } from "../../types/enums";

const UpdateCompanyPage = (props) => (
  <Page enableGoBack title="Bedrijf wijzigen">
    <CenteredPageContentContainer>
      <PaperContainer title="Bedrijf wijzigen">
        <CompanyForm
          companyEmail={props.match.params.id}
          mode={FormMode.UPDATE}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

UpdateCompanyPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }),
};

export default UpdateCompanyPage;



// WEBPACK FOOTER //
// ./src/pages/Company/UpdateCompanyPage.js